import * as React from 'react';
import { cn } from '../../lib/utils.js';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-lg border border-[var(--color-border)] bg-[var(--color-input)] px-3 py-2 text-sm text-[var(--color-foreground)]',
          'shadow-[0_1px_2px_rgba(0,0,0,0.1)]',
          'transition-all duration-200',
          'placeholder:text-[var(--color-muted-foreground)]',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-background)]',
          'focus-visible:border-[var(--color-ring)]',
          'hover:border-[var(--color-muted-foreground)]/50',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-[var(--color-border)]',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[var(--color-foreground)]',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
